module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/webhosting/bravenet_webhosting_ssl_support.png";